import React from "react";
import SOTMI from "../../../Images/SOTM.jpg";
import styles from "./FPR.module.css";

const FPR = () => {
  return <img className={styles.SOTMI} src={SOTMI} alt="Saver Of The Month" />;
};

export default FPR;
